import React from 'react';

import { FormField } from '@wds/form-group';
import { Input } from '@wds/input';

import { HsFormFields, HubspotInputType } from './types';

// TODO: translation required @Richmond, CMS gets the translated labels from the API but how? investigating
// This is an uncontrolled component, so we need to handle the blur event to update the form state
// Recent uncontrolled component changes in the Wrench library do not require the value prop to be passed in the input
// That is the only way to trigger the `onBlur` event, making it controlled will trigger the `onChange` event after every key stroke
// Uncontrolled input does not support autocomplete very well, and setting it off does not really work, so we have to set a name attribute
// https://stackoverflow.com/questions/50347574/how-to-disable-chrome-autocomplete-feature
export default function HubspotInput({ fields, formData, handleOnBlur }: Readonly<HubspotInputType>): JSX.Element {
  return (
    <>
      {fields?.map(
        (field: HsFormFields) =>
          !field.hidden && (
            <FormField key={field.id}>
              <Input
                autoComplete={`invalid-${field.name}`}
                name={field.name}
                data-testid={field.id}
                id={field.id}
                type={field.fieldType}
                color={formData[field?.name]?.color}
                errorMessage={formData[field.name]?.errorMessage}
                label={field.required ? `${field.label} *` : `${field.label}`}
                required={field.required}
                placeholder={field.placeholder}
                stretched
                onBlur={handleOnBlur}
              />
            </FormField>
          )
      )}
    </>
  );
}
